<div class="text-right px-2 pt-2 cursor" mat-dialog-close>
  <img
    class="w-15"
    src="/assets/images/purpl/close-icon.png"
    alt="close-icon"
  />
</div>
<div class="col-md-12 px-4 pb-4">
  <div class="card-heading">Transaction Details</div>
  <div
    ngbNav
    #nav="ngbNav"
    class="tab-coupon profile-tabs brand-manager-dashboard"
  >
    <ng-container ngbNavItem>
      <a ngbNavLink>Details </a>
      <ng-template ngbNavContent>
        <div class="col-md-12 d-flex p-0 mt-4 brand-personal-details">
          <div class="col-md-12 pl-0 right-border">
            <div class="col-12 p-0 mt-1">
              <ng-container>
                <div
                  class="d-flex"
                  *ngIf="
                    details.type !== 'ORDER' && details.type !== 'ORDER_PAYMENT'
                  "
                >
                  <div
                    class="col-md-7 p-0"
                    *ngIf="
                      details.type !== 'PAYMENT' &&
                      details.type !== 'ORDER_PAYMENT'
                    "
                  >
                    <div class="detail-height">
                      <div class="label-name text-style mb-1">
                        {{
                          renderTransactionNameLabel(
                            details.type,
                            details.transaction_type,
                            details.sender
                          )
                        }}
                      </div>
                      <div
                        [ngClass]="
                          profileID !== 0
                            ? 'label-value text-style link-bold-underline'
                            : 'label-value text-style unregistered'
                        "
                        (click)="onViewProfile(profileID)"
                      >
                        {{
                          renderTransactionName(
                            details.type,
                            details.transaction_type,
                            details.sender,
                            details.receiver,
                            details.transaction_object
                          )
                        }}
                      </div>
                    </div>
                    <div
                      class="detail-height"
                      *ngIf="details.type === 'REMITTANCE'"
                    >
                      <div class="label-name text-style mb-1">
                        Receiver name entered by the sender
                      </div>
                      <ng-container>
                        <div class="label-value text-style">
                          {{
                            details?.transaction_object?.receiver_name ?? "-"
                          }}
                        </div>
                      </ng-container>
                    </div>

                    <ng-container
                      *ngIf="
                        details.type !== 'CASH_IN' &&
                        details.type !== 'ORDER_PAYMENT'
                      "
                    >
                      <div class="detail-height">
                        <div class="label-name text-style mb-1">
                          Remittance Platform
                        </div>
                        <div class="label-value text-style">
                          {{
                            renderRemittancePlatform(
                              details.type,
                              details.transaction_object
                            ) ?? "-"
                          }}
                        </div>
                      </div>
                      <div class="detail-height">
                        <div class="label-name text-style mb-1">
                          Sender relation
                        </div>
                        <div class="label-value text-style">
                          {{
                            renderRelationship(
                              details.type,
                              details.transaction_object
                            ) ?? "-"
                          }}
                        </div>
                      </div>
                    </ng-container>

                    <div
                      class="detail-height"
                      *ngIf="details.type !== 'CASH_IN'"
                    >
                      <div>
                        <div class="label-name text-style mb-1">Amount</div>
                        <div class="label-value text-style">
                          ${{ renderAmount(details.transaction_object) }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="detail-height"
                      *ngIf="details.type !== 'CASH_IN'"
                    >
                      <div
                        *ngIf="
                          details?.remittance === 'Ria' &&
                          (details?.status === 'Accepted' ||
                            details?.status === 'Moved To Wallet')
                        "
                      >
                        <div class="label-name text-style mb-1">Fees</div>
                        <div class="label-value text-style">
                          ${{
                            renderTransactionFee(details.transaction_object)
                          }}
                        </div>
                      </div>
                    </div>

                    <ng-container *ngIf="details.type === 'CASH_IN'">
                      <div class="detail-height">
                        <i
                          class="label-name text-style mb-1"
                          ngbTooltip="The amount that will be credited to the user's wallet."
                          >Amount</i
                        >
                        <div class="label-value text-style">
                          {{ details?.amount ?? "-" | number }}
                        </div>
                      </div>
                      <div class="detail-height">
                        <i
                          class="label-name text-style mb-1"
                          ngbTooltip="The Partner's fees for the service that the user must pay."
                          >Partner Fees</i
                        >
                        <div class="label-value text-style">
                          {{
                            details?.transaction_object?.amounts?.partner_fees
                              ?.value ?? "-"
                          }}
                        </div>
                      </div>
                      <div class="detail-height">
                        <i
                          class="label-name text-style mb-1"
                          ngbTooltip="Purpl's fees for the service that the user must pay."
                          >Purpl Fees</i
                        >
                        <div class="label-value text-style">
                          {{
                            details?.transaction_object?.amounts?.purpl_fees
                              ?.value
                          }}
                        </div>
                      </div>
                      <div class="detail-height">
                        <i
                          class="label-name text-style mb-1"
                          ngbTooltip="The total amount that the user must pay (credit + purpl_fees + partner_fees)."
                          >Total Amount</i
                        >
                        <div class="label-value text-style">
                          {{
                            details?.transaction_object?.amounts?.total?.value
                          }}
                        </div>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="details.type === 'CASH_OUT'">
                      <div class="detail-height">
                        <div class="label-name text-style mb-1">
                          Cash out partner
                        </div>
                        <div class="label-value text-style">
                          {{
                            details?.transaction_object
                              ?.cash_out_partner_name ?? "-"
                          }}
                        </div>
                      </div>
                      <div class="detail-height">
                        <div class="label-name text-style mb-1">
                          Cash out fee
                        </div>
                        <div class="label-value text-style">
                          {{
                            this.details?.transaction_object?.extra_data
                              ?.amounts?.fees?.value ?? "-"
                          }}
                          {{
                            this.details?.transaction_object?.extra_data
                              ?.amounts?.fees?.currency ?? ""
                          }}
                        </div>
                      </div>
                    </ng-container>
                  </div>

                  <div
                    class="col-md-5 p-0"
                    *ngIf="
                      details.type !== 'PAYMENT' &&
                      details.type !== 'ORDER_PAYMENT'
                    "
                  >
                    <div class="detail-height">
                      <div class="label-name text-style mb-1">
                        {{
                          renderLabelDate(
                            details.type,
                            details.transaction_object
                          )
                        }}
                      </div>
                      <div class="label-value text-style">
                        {{
                          details?.transaction_object?.datetime_created
                            | date : "shortTime"
                        }}
                        -
                        {{
                          details?.transaction_object?.datetime_created
                            | date : " EEE, MMM d, y"
                        }}
                      </div>
                    </div>

                    <ng-container *ngIf="details.type !== 'CASH_IN'">
                      <div class="detail-height">
                        <div class="label-name text-style mb-1">
                          {{ locationLabel }} Location
                        </div>
                        <div class="label-value text-style">
                          {{ renderSenderCountry(details.type) ?? "-" }}
                        </div>
                      </div>
                      <div class="detail-height">
                        <div class="label-name text-style mb-1">
                          Transfer reason
                        </div>
                        <div class="label-value text-style">
                          {{ renderTransferReason(details.type) ?? "-" }}
                        </div>
                      </div>
                    </ng-container>
                    <div class="detail-height">
                      <div class="label-name text-style mb-1">
                        Transaction ID
                      </div>
                      <div class="label-value text-style">
                        {{
                          details?.transaction_object?.partner_reference ?? "-"
                        }}
                      </div>
                    </div>
                    <div class="detail-height">
                      <div class="label-name text-style mb-1">
                        Referrence Number
                      </div>
                      <div
                        class="label-value text-style"
                        *ngIf="details.type !== 'TRANSFER'"
                      >
                        {{
                          details?.transaction_object?.purpl_reference ?? "-"
                        }}
                      </div>
                    </div>
                    <!-- <div
                      class="detail-height"
                      *ngIf="details.type !== 'CASH_IN'"
                    >
                      <div>
                        <div class="label-name text-style mb-1">Amount</div>
                        <div class="label-value text-style">
                          ${{ renderAmount(details.transaction_object) }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="detail-height"
                      *ngIf="details.type !== 'CASH_IN'"
                    >
                      <div
                        *ngIf="
                          details?.remittance === 'Ria' &&
                          (details?.status === 'Accepted' ||
                            details?.status === 'Moved To Wallet')
                        "
                      >
                        <div class="label-name text-style mb-1">Fees</div>
                        <div class="label-value text-style">
                          ${{
                            renderTransactionFee(details.transaction_object)
                          }}
                        </div>
                      </div>
                    </div> -->
                  </div>
                </div>
                <!-- Card Details for top up -->
                <div *ngIf="details?.transaction_object?.type === 'top-up'">
                  <app-user-card-top-up
                    [details]="CARD_DETAILS"
                  ></app-user-card-top-up>
                </div>

                <!-- Payment details -->
                <div
                  class="col-md-12 p-0"
                  *ngIf="
                    details.type === 'PAYMENT' ||
                    details.type === 'ORDER_PAYMENT'
                  "
                >
                  <app-user-payment-details
                    [details]="details"
                  ></app-user-payment-details>
                </div>

                <!-- Voucher payment details -->
                <div class="col-md-12 p-0" *ngIf="details.type === 'ORDER'">
                  <app-user-voucher-details
                    [details]="details"
                  ></app-user-voucher-details>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-container>

    <!-- Status History -->
    <ng-container ngbNavItem>
      <a ngbNavLink>Status History</a>
      <ng-template ngbNavContent>
        <div class="col-md-12 d-flex p-0 mt-4 brand-transaction-details">
          <div class="col-md-12 p-0">
            <div class="container-view">
              <table class="table table-bordered listing-table">
                <tbody>
                  <tr *ngFor="let col of STATUS_HISTORY" class="cell_">
                    <td>
                      <div class="label_ mb-1 ml-1">
                        {{ col.status | titlecase }}
                      </div>
                    </td>
                    <td>
                      <div class="label-text-value ml-1">
                        {{
                          (col?.datetime_updated
                            ? col?.datetime_updated
                            : col?.updatedAt
                          ) | date : "shortTime"
                        }}
                        -
                        {{
                          (col?.datetime_updated
                            ? col?.datetime_updated
                            : col?.updatedAt
                          ) | date : " EEE, MMM d, y"
                        }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </div>
  <div [ngbNavOutlet]="nav"></div>
</div>
